"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkMeterLockedByImplausibleReadingResult = void 0;
exports.default = reducer;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _meterReadingMainActions = require("../actions/meterReading/meterReadingMainActions");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var checkMeterLockedByImplausibleReadingResult = exports.checkMeterLockedByImplausibleReadingResult = function checkMeterLockedByImplausibleReadingResult(meter) {
  return meter.lockReasons.filter(function (val) {
    return val === 'LOCKED_BY_IMPLAUSIBLE_LAST_READING_RESULT';
  }).length > 0;
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    loading: true,
    currentStep: 'reading'
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _meterReadingMainActions.LOAD_CURRENT:
      return _objectSpread(_objectSpread({}, state), {}, {
        devices: action.data.devices,
        currentPageId: action.data.currentPageId
      });
    case _meterReadingMainActions.LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: action.data.loading
      });
    case _meterReadingMainActions.PAGINATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentPageId: action.data.currentPageId,
        errorObjects: []
      });
    case _meterReadingMainActions.CURRENT_STEP:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentStep: action.data.currentStep
      });
    case _meterReadingMainActions.ERROR_LIST:
      return _objectSpread(_objectSpread({}, state), {}, {
        errorObjects: action.data.errorObjects
      });
    case _meterReadingMainActions.ERROR_HINT:
      return _objectSpread(_objectSpread({}, state), {}, {
        errorHint: {
          code: action.data.code,
          args: action.data.args
        }
      });
    default:
      return state;
  }
}